/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { COLORS2, LAYOUT2, TYPOGRAPHY2 } from '../Styles';

const TOGGLE_CONTAINER_STYLE = css`
  label: TOGGLE_CONTAINER_STYLE;
  height: 44px;
  display: flex;
  align-items: center;
  gap: ${LAYOUT2.spacing1}px;
  cursor: pointer;
`;

const TOGGLE_LABEL_STYLE = css`
  label: TOGGLE_LABEL_STYLE;
  color: var(--text);
  ${TYPOGRAPHY2.xSmallBold}
  user-select: none;
`;

const TOGGLE_LABEL_STYLE_ALWAYS_DARK = css`
  color: ${COLORS2.alwaysDark.text.white};
`;

const TOGGLE_TRACK_STYLE = css`
  label: TOGGLE_TRACK_STYLE;
  width: 40px;
  height: 20px;
  background: var(--background);
  border: 1px solid var(--border);
  position: relative;
  transition: all 0.2s ease;
`;

const TOGGLE_TRACK_STYLE_ALWAYS_DARK = css`
  background: ${COLORS2.alwaysDark.background.light};
  border: 1px solid ${COLORS2.alwaysDark.border.darkGray};
`;

const TOGGLE_SLIDER_STYLE = css`
  label: TOGGLE_SLIDER_STYLE;
  width: 18px;
  height: 18px;
  position: absolute;
  top: 0;
  transition: transform 0.2s ease;
  background: var(--backgroundGreen3);
`;

const TOGGLE_SLIDER_STYLE_ALWAYS_DARK = css`
  background: ${COLORS2.alwaysDark.green};
`;

const TOGGLE_SLIDER_OFF_STYLE = css`
  transform: translateX(0);
`;

const TOGGLE_SLIDER_ON_STYLE = css`
  transform: translateX(20px);
`;

export const CustomToggle = ({
  isOn,
  onToggle,
  onLabel = 'On',
  offLabel = 'Off',
  alwaysDark = true,
}: {
  isOn: boolean;
  alwaysDark?: boolean;
  onToggle: () => void;
  offLabel?: string;
  onLabel?: string;
}) => (
  <div
    css={TOGGLE_CONTAINER_STYLE}
    onClick={e => {
      e.stopPropagation();
      onToggle();
    }}
  >
    <div css={[TOGGLE_TRACK_STYLE, alwaysDark ? TOGGLE_TRACK_STYLE_ALWAYS_DARK : '']}>
      <div css={[TOGGLE_SLIDER_STYLE, alwaysDark ? TOGGLE_SLIDER_STYLE_ALWAYS_DARK : '', isOn ? TOGGLE_SLIDER_ON_STYLE : TOGGLE_SLIDER_OFF_STYLE]} />
    </div>
    <div css={[TOGGLE_LABEL_STYLE, alwaysDark ? TOGGLE_LABEL_STYLE_ALWAYS_DARK : '']}>
      {isOn ? onLabel : offLabel}
    </div>
  </div>
);
